import { render, staticRenderFns } from "./win-woldcup-modal.vue?vue&type=template&id=ed3419a0&"
import script from "./win-woldcup-modal.vue?vue&type=script&lang=js&"
export * from "./win-woldcup-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports